import { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { Text } from 'components/Text/Text';
import { TabContext } from 'containers/TabContext';
import { colors, transition } from 'theme/theme';

const Input = styled.input<{ $isTabbing?: boolean }>`
  width: 100%;
  height: 100%;
  margin: 0;
  appearance: none;
  cursor: pointer;
  ${(props) =>
    !props.$isTabbing &&
    `
    &:focus {
      outline: 0;
    }
  `}
`;
const Container = styled.div<{ $checked?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  height: 100%;
  border-radius: 10px;
  transition: all ${transition};
  background: ${(props) => (props.$checked ? colors.brandBlue : 'transparent')};
  color: ${(props) => (props.$checked ? 'white' : colors.darkContentGrey)};
  box-shadow: 0 0 0 1px
    ${(props) => (props.$checked ? colors.brandBlue : colors.elementGrey)} inset;

  &:hover {
    background: ${colors.brandBlue} !important;
    color: white !important;
    box-shadow: 0 0 0 1px ${colors.brandBlue} inset;
  }

  input[type='radio'] {
    border-radius: 10px;
  }
`;

type Props = {
  'data-qa-id'?: string;
  id?: string;
  name?: string;
  value: string | boolean | number;
  label: ReactNode;
  checked: boolean;
  onChange?: (
    arg0:
      | (string | null | undefined)
      | (boolean | null | undefined)
      | (number | null | undefined),
  ) => void;
  onClick?: () => void;
  alignTop?: boolean;
  hideRadioButtons?: boolean;
  disabled?: boolean;
};

export function SquareRadioButton({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  hideRadioButtons,
  ...props
}: Props) {
  return (
    <Container $checked={checked}>
      <Box top={0} left={0} position="absolute" width={1} height="100%">
        <TabContext.Consumer>
          {(isTabbing) => (
            <Input
              type="radio"
              name={name}
              id={id}
              checked={checked}
              value={typeof value === 'string' ? value : value.toString()}
              onChange={(e) => {
                e.stopPropagation();

                if (onChange) {
                  onChange(value);
                }
              }}
              $isTabbing={isTabbing}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
            />
          )}
        </TabContext.Consumer>
      </Box>
      <label htmlFor={id}>
        <Text styleAs="h4">{label}</Text>
      </label>
    </Container>
  );
}
